import { Component, OnInit } from '@angular/core';
import { CommittesService } from '../../services/committes-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Committes, MembersVM } from '../../models/committes';
import { UsersService } from '../../../users/services/users-service';
import { QueryModel } from '../../../../shared/Models/queryModel';
import { Router } from '@angular/router';
import { AddingWithAttatchementsBaseComponent } from '../../../../shared/Components/adding-with-attatchements-base/adding-with-attatchements-base.component';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FileVm } from '../../../../shared/Models/fileVm';

@Component({
  selector: 'app-add-committe',
  templateUrl: './add-committe.component.html',
  styleUrls: ['./add-committe.component.scss'],
})
export class AddCommitteComponent extends AddingWithAttatchementsBaseComponent implements OnInit {
  model = {} as Committes;
  isEdit = false;
  members = [];
  query = new QueryModel();
  isLoading: boolean = false;
  uploadThumbnail: boolean[] = [];
  formData = new FormData();
  validPhoto: boolean[] = [];
  formDataList: FormData[] = [];
  attachments: Observable<FileVm[]>;
  memberIndex: number = 0;
  responseError: boolean = false;
  // Derived view: selected members objects, kept in the same order as model.membersIds
  selectedMembersView: any[] = [];
  constructor(
    public service: CommittesService,
    private diagRef: NbDialogRef<AddCommitteComponent>,
    private toast: NbToastrService,
    private memberService: UsersService,
    private route: Router,
    private uploadservice: uploadService
  ) {
    super(service, null);
  }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    this.query.pageSize = 1000;
    this.query.searchTerm = 'isDeleted:false';
    this.memberService.getAll(this.query, '').subscribe((res: any) => {
      this.members = res.result;
      // Build selected view if there are preselected members (especially on edit)
      this.updateSelectedMembersView();
    });
    if (this.isEdit) {
      this.InialUploadPhotos();
      this.updateSelectedMembersView();
      if (!this.model.memebers) {
        this.model.memebers = [] as MembersVM[];
      }
    }
    if (!this.isEdit) {
      this.model = {} as Committes;
      this.model.nameAR = '';
      this.model.nameEN = '';
      this.model.taskAR = '';
      this.model.taskEN = '';
      this.model.code = '';
      this.model.memebers = [] as MembersVM[];
      this.uploadservice.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  InialUploadPhotos() {
    if (this.model.memebers !== null && this.model.memebers !== undefined) {
      this.memberIndex = this.model.memebers.length;
      this.model.memebers.forEach((member, index) => {
        if (!member.picPath || member.picPath === null || member.picPath === undefined) {
          this.uploadThumbnail[index] = true;
          this.validPhoto[index] = false;
        }
        else {
          this.uploadThumbnail[index] = false;
          this.validPhoto[index] = true;
        }
      });
    }

  }

  getFormData(event) {
    this.formData = event;
    this.uploadservice.uploadPhoto(this.formData)
      .subscribe({
        next: data => {
          this.model.memebers.forEach((member, index) => {
            if (index + 1 === this.memberIndex) {
              member.pic.fileName = data && data.fileName ? data.fileName : '';
              member.pic.path = data && data.path ? data.path : '';
              member.pic.originalFileName = data && data.originalFileName ? data.originalFileName : '';
            }
          });
        },
        error: err => {
          console.error("Upload failed", err);
        }
      });
    if (event) this.validPhoto[this.memberIndex] = true;
  }

  removePhoot(index: number) {
    this.uploadThumbnail[index] = true;
    this.validPhoto[index] = false;
    this.model.memebers[index].picPath = '';
    this.model.memebers[index].pic = {} as FileVm;

  }

  // Keep selectedMembersView in sync with model.membersIds preserving order
  updateSelectedMembersView() {
    if (!this.model || !Array.isArray(this.model.membersIds) || !Array.isArray(this.members)) {
      this.selectedMembersView = [];
      return;
    }
    const idToUser = new Map<number, any>();
    this.members.forEach((u: any) => idToUser.set(u.id, u));
    this.selectedMembersView = (this.model.membersIds as any[])
      .map((id: any) => idToUser.get(id))
      .filter((u) => !!u);
  }

  // Handle select changes (Nebular emits selectedChange for nb-select)
  onMembersSelectedChange(newSelected: any[]) {
    this.model.membersIds = newSelected as any;
    this.updateSelectedMembersView();
  }

  // Drag-and-drop handler for selected members ordering (edit mode UX)
  dropSelectedMember(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.selectedMembersView, event.previousIndex, event.currentIndex);
    // Reflect the new order back into membersIds
    this.model.membersIds = this.selectedMembersView.map((u: any) => u.id) as any;
  }

  save() {
    this.saveEntity(this.model).
      pipe(
        catchError(() => {
          this.responseError = true;
          console.log('error here in combine latest ');
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('حدث خطأ أثناء إضافة اللجنة', '', { status: 'danger', duration: 3000 });
          return of(null);
        })
      )
      .subscribe({
        next: (res) => {
          if (!this.responseError) {
            this.isLoading = false;
            this.diagRef.close('true');
            this.toast.show('تم اضافة لجنة  بنجاح', '', { status: 'success', duration: 3000 });
          }
        },
        error: () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('حدث خطأ أثناء إضافة اللجنة', '', { status: 'danger', duration: 3000 });
        },
      });
    //   this.service.post(this.model).subscribe((res) => {
    //   this.diagRef.close('true');
    //   this.toast.show('تم إضافة لجنة جديدة بنجاح', '', { status: 'success', duration: 3000 });
    // });
  }
  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }
  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.code && this.model.nameAR && this.model.taskAR;
  }

  addMemberRow() {
    this.model.memebers.push({
      nameAR: '',
      nameEN: '',
      role: '',
      roleEn: '',
      picPath: '',
      pic: {} as FileVm
    } as MembersVM)
    this.uploadThumbnail.push(true);
    this.validPhoto.push(false);
    this.memberIndex++;
    this.toast.show('تم اضافة عضو جديد بنجاح يرجي ملئ بيانات العضو', '', { status: 'success', duration: 3000 });
  }

  removeMemberRow(index: number) {
    this.memberIndex--;
    this.uploadThumbnail.pop();
    this.validPhoto.pop();
    this.model.memebers.splice(index, 1)
  }

  update() {
    return this.service.put(this.model.id, this.model)
      .pipe(
        catchError(() => {
          this.responseError = true;
          console.log('error here in combine latest ');
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('حدث خطأ أثناء تعديل اللجنة', '', { status: 'danger', duration: 3000 });
          return of(null);
        })
      )
      .subscribe({
        next: (res) => {
          if (!this.responseError) {
            this.isLoading = false;
            this.diagRef.close('true');
            this.toast.show('تم التعديل  بنجاح', '', { status: 'success', duration: 3000 });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل  ', 'خطأ', { status: 'danger', duration: 3000 });
        },
      });
  }
}
